import React, { useEffect, useId } from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { useGlobalSearchContext } from "../GlobalSearchContext"

export const GlobalSearchStatus = React.memo(() => {
  const { t } = useTranslation()
  const { isLoading, searchTerm, hasResults, onStatusRegister } =
    useGlobalSearchContext()
  const id = useId()

  useEffect(() => {
    onStatusRegister(id)
  }, [id, onStatusRegister])

  const hasQuery = (searchTerm?.length ?? 0) >= 2

  let message: string | undefined
  if (isLoading && !hasResults) {
    message = t("GlobalSearch.Loading")
  } else if (hasQuery && !hasResults) {
    message = t("GlobalSearch.NoResults")
  }

  return (
    <div
      id={id}
      role="status"
      aria-live="polite"
      className={classNames("global-search__status", {
        "visually-hidden": !message
      })}
    >
      {message}
    </div>
  )
})
